import React from "react";
import PropTypes from "prop-types";

/**
 * Shared Button — Patient module outline style is the default primary.
 * API unchanged: text, icon, onClick, variant, size, loading, disabled.
 */
const Button = ({
  text,
  icon,
  className = "",
  onClick,
  type = "button",
  disabled = false,
  loading = false,
  variant = "primary",
  size = "md",
  ...props
}) => {
  const variantClasses = {
    primary:
      "text-indigo-700 bg-white border border-indigo-300 hover:bg-indigo-50",
    secondary:
      "text-slate-700 bg-white border border-slate-300 hover:bg-slate-50",
    outline:
      "text-indigo-700 bg-white border border-indigo-300 hover:bg-indigo-50",
    danger:
      "text-red-700 bg-white border border-red-200 hover:bg-red-50",
    success:
      "text-emerald-700 bg-white border border-emerald-300 hover:bg-emerald-50",
    solid:
      "bg-indigo-500 text-white border border-indigo-500 hover:bg-indigo-600",
  };

  const sizeClasses = {
    sm: "h-8 px-2.5 text-[11px]",
    md: "h-9 px-3 text-sm",
    lg: "h-10 px-4 text-sm",
  };

  const baseClasses =
    "inline-flex items-center justify-center gap-1.5 rounded-md font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed";

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`${baseClasses} ${variantClasses[variant] || variantClasses.primary} ${sizeClasses[size] || sizeClasses.md} ${className}`}
      {...props}
    >
      {loading ? (
        <span className="w-3.5 h-3.5 border-2 border-current border-t-transparent rounded-full animate-spin" />
      ) : (
        icon && <span className="flex items-center shrink-0">{icon}</span>
      )}
      <span>{text}</span>
    </button>
  );
};

Button.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  variant: PropTypes.oneOf([
    "primary",
    "secondary",
    "outline",
    "danger",
    "success",
    "solid",
  ]),
  size: PropTypes.oneOf(["sm", "md", "lg"]),
};

export default Button;
